import styled from "styled-components";
import { motion } from "framer-motion";
import Button from "../../../components/Atoms/Button";
import { tokens } from "../../../design/tokens";

/* Esta tela e o mesmo padrao do Login: coluna de formulario centrada sobre o
   palco preto. Mantida em espelho de proposito — sao a mesma cena para o
   usuario (entrar na conta), e divergir aqui e o que faz um produto parecer
   costurado de pedacos. Ver "Coluna de formulario de 380px" no DESIGN.md. */

export const Container = styled.div`
  /* Era 'width: 100vw', que inclui a largura da barra de rolagem e produz
     scroll horizontal sempre que a pagina rola na vertical. */
  max-width: 100%;
  min-height: 100vh;

  @media (max-width: 768px) {
    height: auto;
    padding: 2rem 0 0 0;
  }
`;

export const ContentWrapper = styled.main`
  width: 100%;
  max-width: 100%;
  min-height: 100vh;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const LoginWrapper = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  width: 100%;

  @media (max-width: 768px) {
    padding: 0 ${tokens.space.lg};
  }

  /* O <Form> e item flex de uma coluna com align-items: center, entao encolhe
     para a largura do conteudo se a largura nao for declarada aqui — era o que
     fazia o max-width do FormWrapper nunca valer. */
  form {
    width: 100%;
    max-width: 380px;

    @media (max-width: 425px) {
      max-width: 100%;
    }
  }
`;

/* O logo navega de volta para o login. Era uma imagem nua com onClick: uma
   rota que so existia para quem usa mouse. */
export const LogoButton = styled.button`
  display: block;
  padding: 0;
  border: 0;
  background: none;
  cursor: pointer;

  img {
    display: block;
    height: 120px;
    margin-bottom: ${tokens.space.lg};
  }
`;

export const FormWrapper = styled.div`
  width: 100%;
  max-width: 380px;

  display: flex;
  flex-direction: column;
  gap: ${tokens.space.xl};
  align-items: center;

  padding: ${tokens.space.lg} 0;

  @media (max-width: 768px) {
    max-width: 100%;
  }

  /* Input e Button trazem margin-top propria, herdada de telas que empilham
     por margem. Aqui quem empilha e o gap acima. Ver "A Regra do Gap sobre a
     Margem" no DESIGN.md. Substitui o 'height: 300px' + 'space-around', que
     distribuia o espaco em vez de defini-lo: com dois filhos, o intervalo
     virava o que sobrasse da altura fixa. */
  && > div,
  && > button {
    margin-top: 0;
  }

  h1 {
    font-family: ${tokens.font.title.family};
    font-size: ${tokens.font.title.size};
    font-weight: ${tokens.font.title.weight};
    /* Era Carvao de Tinta (#353536) sobre o palco preto: 1.56:1, praticamente
       invisivel. E o "Don't" literal do DESIGN.md — carvao e a tinta SOBRE o
       ouro, nunca sobre o palco. Branco da 19.17:1. */
    color: ${tokens.color.textWhite};
    letter-spacing: -0.02em;
    margin: 0;
    text-align: center;
  }

  && .back-to-login {
    border: none;
    background: none;
    cursor: pointer;
    color: ${tokens.color.textMist};
    font-family: ${tokens.font.body.family};
    font-size: ${tokens.font.body.size};
    font-weight: ${tokens.font.label.weight};
    transition: color 0.3s;

    /* Alvo de toque crescido por padding e cancelado por margem negativa, para
       nao alterar o ritmo da coluna — mesma tecnica do icone de senha. */
    padding: 8px 12px;
    margin: -8px -12px;

    &:hover {
      color: ${tokens.color.focusAmber};
    }
  }
`;

/* Campos e acoes dividem a largura da coluna, para a coluna ter uma borda
   direita so. Substitui o 'margin-top: -15px' magico do botao. */
export const StyledButton = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;
